//假设这里定义用户功能模块的api请求

//一般根据具体的接口服务模块约定
const baseURL = '/api';
import listRequest from '../../js/listRequest.js';

export const classroomApi = {
    //最简单的写法，列表啥也不用做
    getList(opt: any, pageData?: any) {
        var servicesPath = baseURL + '/v1/classroom/list';
        let context = opt.context;
        let pager = opt.pager;
        let initCodeRules = opt.initCodeRules;
        listRequest.request({
            url: servicesPath,
            context: context,
            pager: pager,
            waitingtip: '加载中，请稍等...',
            data: {},
            urlQueryParmas: opt.urlQueryParmas || {},
            prepareRender(data: any) {
                //如果列表需要显示编码的中文，则需要重写prepareRender
                context.$pageHelper.initListRowsCode(data.data.list, initCodeRules);
                return data;
            }
        });
    },
    //修改与新增所用的方法
    saveClasses(opt: any) {
        var servicesPath = baseURL + '/v1/classroom';
        let context = opt.context;
        let pageData = opt.data || {};
        let ajaxType = 'POST';
        if (pageData._id != undefined && pageData._id != '') {
            ajaxType = 'PUT';
            servicesPath += '/' + pageData._id;
            delete pageData._id;
        }
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '保存中，请稍等...',
            headers: {
                'content-type': 'application/json'
            },
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 删除教室
    deleteRecord(opt: any) {
        var servicesPath = baseURL + '/v1/classroom';
        let context = opt.context;
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj._id;

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'DELETE' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    // 查看教室详情
    getClasses(opt: any) {
        var servicesPath = baseURL + '/v1/classroom';
        let context = opt.context;
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj._id;
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    }
};
